<app-home-widget height="50px">
  @if (isFaqView) {
    <app-admin-toolbar-faq />
  } @else if (isUserView) {
    <app-admin-toolbar-user />
  } @else if (isResponsibleView) {
    <app-admin-toolbar-responsible />
  } @else if (isHyperlinkView) {
    <app-admin-toolbar-hyperlink />
  } @else if (isGlossaryView) {
    <app-admin-toolbar-glossary />
  } @else if (isReportView) {
    <app-admin-toolbar-report />
  }
</app-home-widget>
